export enum ListingStatus {
  SOLD = "sold",
  PUBLISHED = "published",
  DEACTIVATED = "deactivated",
  DRAFT = "draft",
  PROCESSING = "processing",
}
